'use client';

import { Typography } from 'lighthouse';

import { StoreFilterChipsProps } from './models';

export const StoreFilterChips = ({ label, options, value, onChange, bleed = true }: StoreFilterChipsProps) => (
    <div
        role='group'
        aria-label={label}
        className={`nice-scroll flex gap-2 overflow-x-auto py-1 md:flex-wrap md:overflow-visible ${bleed ? '-mx-4 px-4 md:mx-0 md:px-0' : 'px-0'}`}>
        {options.map((option) => {
            const isActive = option.value === value;

            return (
                <button
                    type='button'
                    key={option.value || 'all'}
                    aria-pressed={isActive}
                    onClick={() => onChange(option.value)}
                    className={`min-h-10 shrink-0 cursor-pointer rounded-full border border-solid px-4 py-1.5 transition-all duration-200
                    focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-secondary
                    motion-reduce:transition-none ${
                        isActive
                            ? 'border-primary bg-primary text-white shadow-sm'
                            : 'border-N200 bg-white text-blackMediumEmphasis hover:border-primary/30 hover:bg-primary/5 hover:text-primary'
                    }`}>
                    <Typography
                        variant='caption'
                        component='span'
                        fontWeight={isActive ? 700 : 500}
                        className={`whitespace-nowrap leading-4 ${isActive ? 'text-white' : ''}`}>
                        {option.title}
                    </Typography>
                </button>
            );
        })}
    </div>
);
